import type { RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { ReportPage } from './pages/ReportPage';
import { ReportsPage } from './pages/ReportsPage';
import { REPORT_TABS } from './reports.paths';

export const REPORT_ROUTES: RouteObject[] = [
  { path: 'reports', element: <ReportsPage /> },
  ...recordTabRoutes('reports/:key', REPORT_TABS, (tab) => <ReportPage tab={tab} />),
];
